import config from '../config'
import { addAuthToken } from '../helper'

const PaymentMethodManager = {
  putPaymentMethod: async (payload, companyId) => {
    const ccConfig = addAuthToken({
      ...config.PUT,
      body: JSON.stringify(payload),
    })

    const response = await fetch(`${config.BASE_URL}/api/companies/${companyId}/update_company`, {
      ...ccConfig,
    })

    return await response.json()
  },
}

export default PaymentMethodManager
